module.exports = __webpack_public_path__ + "img/Support-skill-508.24bd7edc.png";